import { ModalHeader } from '@/components/Modal'
import { Warning } from '@mui/icons-material'
import { useTexts } from './useTexts'

export function Header() {
  const texts = useTexts()

  return (
    <ModalHeader
      title={texts.header.title}
      avatar={<Warning sx={{ color: t => t.vars.palette.error.main }} />}
    />
  )
}
